import {
  localDateToSolarHijri,
  SOLAR_HIJRI_MONTHS_FA,
  todayBusinessDate,
  toPersianDigits,
} from '@saay/formatting';

const EXPIRY_TEXT_PATTERN = /^(\d{2})\/(\d{2})$/;

/** Solar Hijri card expiry for display (XAP-34): API `YY/MM` → «مهر ۱۴۱۰». */
export function formatAdminPhysicalCardExpiryFa(expiryText: string): string {
  const match = EXPIRY_TEXT_PATTERN.exec(expiryText);
  if (match === null) {
    return toPersianDigits(expiryText);
  }
  const yy = Number(match[1]);
  const month = Number(match[2]);
  if (month < 1 || month > 12) {
    return toPersianDigits(expiryText);
  }
  const century = Math.floor(localDateToSolarHijri(todayBusinessDate()).year / 100) * 100;
  const monthName = SOLAR_HIJRI_MONTHS_FA[month - 1] ?? '';
  return `${monthName} ${toPersianDigits(String(century + yy))}`;
}
